function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var EventManager=
function EventManager(id,firstName,lastName,email,phone){_classCallCheck(this,EventManager);
this.id=id;
this.firstName=firstName;
this.lastName=lastName;
this.email=email;
this.phone=phone;
};


export default EventManager;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9tb2RlbHMvRXZlbnRNYW5hZ2VyLmpzIl0sIm5hbWVzIjpbIkV2ZW50TWFuYWdlciIsImlkIiwiZmlyc3ROYW1lIiwibGFzdE5hbWUiLCJlbWFpbCIsInBob25lIl0sIm1hcHBpbmdzIjoib0pBQU1BLGE7QUFDSixzQkFBWUMsRUFBWixDQUFnQkMsU0FBaEIsQ0FBMkJDLFFBQTNCLENBQXFDQyxLQUFyQyxDQUE0Q0MsS0FBNUMsQ0FBbUQ7QUFDakQsS0FBS0osRUFBTCxDQUFVQSxFQUFWO0FBQ0EsS0FBS0MsU0FBTCxDQUFpQkEsU0FBakI7QUFDQSxLQUFLQyxRQUFMLENBQWdCQSxRQUFoQjtBQUNBLEtBQUtDLEtBQUwsQ0FBYUEsS0FBYjtBQUNBLEtBQUtDLEtBQUwsQ0FBYUEsS0FBYjtBQUNELEM7OztBQUdILGNBQWVMLGFBQWYiLCJmaWxlIjoiRXZlbnRNYW5hZ2VyLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJjbGFzcyBFdmVudE1hbmFnZXIge1xuICBjb25zdHJ1Y3RvcihpZCwgZmlyc3ROYW1lLCBsYXN0TmFtZSwgZW1haWwsIHBob25lKSB7XG4gICAgdGhpcy5pZCA9IGlkO1xuICAgIHRoaXMuZmlyc3ROYW1lID0gZmlyc3ROYW1lO1xuICAgIHRoaXMubGFzdE5hbWUgPSBsYXN0TmFtZTtcbiAgICB0aGlzLmVtYWlsID0gZW1haWw7XG4gICAgdGhpcy5waG9uZSA9IHBob25lO1xuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IEV2ZW50TWFuYWdlcjtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/models/EventManager.js
// module id = 2365
// module chunks = 0